export default "__VITE_ASSET__DzBRPSSg__"